import SecondaryButton from "./SecondaryButton";
import { Link } from "react-router-dom";
import React from "react";
import { useRecoilValue } from "recoil";
import { billingAtom } from "../store/billingAtom";
import useCompanyUsage from "../hooks/useCompanyUsage";

const PlanUsageCard = () => {
  useCompanyUsage();

  const billingInfo = useRecoilValue(billingAtom);
  const active_plan = billingInfo?.active_plan?.payment_plan

  return (
    <div className="p-4 rounded-xl flex flex-col gap-4 outline outline-1 outline-offset-[-1px] shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] outline-gray-200">
      <div className="flex items-center justify-between gap-2 text-xs">
        <p className="font-semibold p-0 m-0 text-sm leading-tight text-slate-900">
          {active_plan?.name || "Plan"}
        </p>
        <p className="p-0 m-0 text-sm font-normal leading-tight text-slate-500">
          {billingInfo?.credits_consumed || 0}/
          {billingInfo?.subscription_limit || 100} messages used
        </p>
      </div>

      <div className="w-full bg-gray-200 h-2 rounded-full mt-1">
        <div
          className="bg-purple-600 h-2 rounded-full"
          style={{
            width: `${Math.min(
              (billingInfo?.credits_consumed /
                billingInfo?.subscription_limit) *
                100,
              100
            )}%`,
          }}
        />
      </div>

      <Link to="/settings/plans">
        <SecondaryButton type="button">Upgrade now</SecondaryButton>
      </Link>
    </div>
  );
};

export default PlanUsageCard;
